import {IonContent, IonIcon, IonLabel, IonPage, IonSegmentButton, IonSlide, IonSlides} from '@ionic/react';
import { cardOutline, wifiOutline } from 'ionicons/icons';
import { useEffect, useRef, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router';

import Segment from '../../components/segments/Segment';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';

import './Donation.css';
import Offline from './Offline';
import Online from './Online';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { DonationDoGetAction } from '../../redux/actions/Campaign';
import LoadingContainer from '../../components/loading/LoadingContainer';

interface Props extends RouteComponentProps<{
  campaign_id: string,
  pay_do: string,
}> { }

const Donation: React.FC<Props> = ({ match }) => {
  const slideValues = ["online", "offline"]
  const [defaultSlide, setDefaultSlide] = useState("online");
  const sliderRef = useRef<HTMLIonSlidesElement>(null);

  const dispatch = useAppDispatch()

  const { loading, donationDo } = useAppSelector(state => state.donationDoReducer)

  useEffect(() => {
      dispatch(DonationDoGetAction(match.params.campaign_id));

      return () => {
          dispatch({ type: 'DONATION_DO_GET_RESET' })
      }
  }, [dispatch])

  const segmentClickHandler = (value: any) => {
    setDefaultSlide(value)

    let index = slideValues.findIndex((item) => {
      return item == value
    })

    sliderRef.current?.slideTo(index);
  }

  const slideChangeHandler = async () => {
    var index = await sliderRef.current?.getActiveIndex()
    setDefaultSlide(slideValues[index as number])
  }

  return <LoadingContainer loading={loading}>
  <IonPage className="donation">
    <Toolbar title="حمایت" subTitle={donationDo.title} hasBackButton />

    <LayoutGap />

    <IonContent className="main-content">
      <Segment defaultSlide={defaultSlide} change={(e: any) => segmentClickHandler(e.detail.value)}>
        <IonSegmentButton layout="icon-start" value="online">
          <IonIcon icon={wifiOutline} size="small" />
          <IonLabel>آنلاین</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton layout="icon-start" value="offline">
          <IonIcon icon={cardOutline} size="small" />
          <IonLabel>سایر</IonLabel>
        </IonSegmentButton>
      </Segment>

      <IonSlides ref={sliderRef} onIonSlideDidChange={slideChangeHandler}>
        <IonSlide>
          <Online campaign_id={match.params.campaign_id} pay_do={match.params.pay_do}
          isPlanting={donationDo.isPlanting != undefined ? donationDo?.isPlanting : false}
          seedlings={donationDo.seedlings != undefined ? donationDo?.seedlings : null}
          templates={donationDo.templates != undefined ? donationDo?.templates : null} />
        </IonSlide>
        <IonSlide>
          <Offline campaign_id={match.params.campaign_id} pay_do={match.params.pay_do}
          isPlanting={donationDo.isPlanting != undefined ? donationDo?.isPlanting : false}
          seedlings={donationDo.seedlings != undefined ? donationDo?.seedlings : null} />
        </IonSlide>
      </IonSlides>
    </IonContent>
  </IonPage>
  </LoadingContainer>
}

export default Donation;
